import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import {
  faChevronRight,
  faEye,
  faPen,
  faPlus,
  faPrint,
  faTimes,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import { getUserType } from "../utils/index";
import { PopupMessage } from "../utils/utils";
import Popup from "reactjs-popup";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../layout/datatableConstants";
//import { Chart } from "react-google-charts";
import {
  Chart as ChartJS,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { Chart } from "react-google-charts";
import { counter } from "@fortawesome/fontawesome-svg-core";
import SimpleReactValidator from "simple-react-validator";
ChartJS.register(
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const labels = [
  "Expiring in 3 Months",
  "Expiring in 6 Months",
  "Expiring in 9 Months",
  "Expiring in 12 Months",
  "Expiring in over 12 Months",
];

const Checkbox = ({
  id,
  type,
  name,
  handleClick,
  isChecked,
  attr,
  occupierId,
  netAmt,
  invoiceId,
}) => {
  return (
    <input
      id={id}
      name={name}
      type={type}
      onChange={handleClick}
      checked={isChecked}
      data-attr={attr}
      data-occupierId={occupierId}
      data-netAmt={netAmt}
      data-invoiceId={invoiceId}
    />
  );
};

var reportFilterForm = Yup.object().shape({
  financialYearOne: Yup.string().required("Required"),
  invoiceFrequency: Yup.string().required("Required"),
  chargeType: Yup.string().required("Required"),
  towerId: Yup.string().required("Required"),
  reportType: Yup.string().required("Required"),
});

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseExpiryReport extends React.Component {
  groupId = { value: "" };
  state = {
    landloardArr: [],
    assetArr: [],
    subAssetArr: [],
    towerArr: [],
    companyArr: [],
    cityList: [],
    occupierList: [],
    landloardList: [],
    assetsList: [],
    tableTOShow: "RENT",
    companyDetails: {
      companyPan: "",
    },
    formResponseData: [],
    invoiceList: {},
    invoiceItemList: {},
    initialValues: {
      chargeTypeSelected: "",
      frequencySelected: "",
      chartType: "",
      landloardName: "",
      landloardId: "",
      subAssetName: "",
      subAssetId: "",
      companyName: "",
      companyId: "",
      towerId: "",
      cityName: "",
      cityId: "",
      occupierName: "",
      occupierId: "",
      companyPan: "",
      financialYearOne: "",
      invoiceFrequency: "",
      chargeType: "",
      reportType: ""
    },
    countList: {
      generated: 0,
      draftCount: 0,
      approveCount: 0,
      applyCount: 0,
      cancelCount: 0,
    },
    datatableList: [],
    totalRows: 0,
    loading: false,
    perPage: 10,
    pageNo: 1,
    showStatusOption: false,
    tableCounter: Math.round(),
    columns: [],
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-occupier-landloard`, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          landloardList: data.landloardList,
          //occupierList: data.occupierList,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
    this.processInvoiceItems(1);
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
    
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

  }

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.financialYearTwo = this.formatDate(
      this.state.financialYearTwo
    );
    //this.state.initialValues.financialYearOne = date;
  };

  handleCalculation = (e, index, values) => {
    var total = 0;
    for (const value in values.amount) {
      total += parseInt(values.amount[value]);
    }
    //console.log(total, "total", this.state.formResponseData[index].variance )
    if (typeof index == "undefined") {
      this.setState({ totalInvoiceAmount: total });
    } else {
      var formData = this.state.formResponseData;
      formData[index].variance =
        parseFloat(formData[index].net_charge_amount) - e.target.value;

      this.setState({ totalInvoiceAmount: total, formResponseData: formData }); //, `formResponseData${}` : totalVariance
    }
  };

  valueChangeSubAsset = (newValue, actionMeta) => {
    this.state.initialValues.subAssetId = newValue.value;
    this.state.initialValues.subAssetName = newValue.label;
    this.setState({});
    fetch(`${apiUrl.apiUrl.url}/asset/sub-asset-towers?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          towerArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  valueFrequencyChange = (newValue, actionMeta) => {
    this.state.initialValues.frequencySelected = newValue.value;
    this.setState({});
  };
  valueChangeChargeType = (newValue, actionMeta) => {
    this.state.initialValues.chargeTypeSelected = newValue.value;
    this.state.initialValues.chargeType = newValue.value;
  };

  valueChangeCompany = (newValue, actionMeta) => {
    this.state.initialValues.companyId = newValue.value;
    this.state.initialValues.companyName = newValue.label;
    this.setState({});
    fetch(`${apiUrl.apiUrl.url}/landlord/get-company?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.data, "ata");
        this.setState({
          companyDetails: data.data,
        });
        this.state.initialValues.companyPan = data.data.companyPan;
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChangeAsset = (newValue, actionMeta) => {
    this.state.initialValues.assetId = newValue.value;
    this.state.initialValues.assetName = newValue.label;
    this.setState({});
    //landlord-group/fetch-landlord-list
    fetch(`${apiUrl.apiUrl.url}/asset/asset-sub-assets?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          subAssetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeChk = (val) => {
    console.log(val, "clickec");
  };

  handleChangeLandlord = (newValue, actionMeta) => {
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});

    //landlord-group/fetch-landlord-list
    fetch(
      `${apiUrl.apiUrl.url}/asset/fetch-landlord-all-assets?id=` +
      newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/landlord/get-group-companies?id=` + newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  processDebitItems = (status) => {
    var self = this;
    if (JSON.stringify(this.state.invoiceList) === JSON.stringify({})) {
      self.setState({
        messsagePopup: true,
        popupContent: "Please Select Item to proceed.",
      });
      return false;
    }
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/transaction/approve-debit`,
      data: { list: this.state.invoiceList, processType: status },
    }).then(function (response) {
      if (!response.data.success) {
        //actions.setSubmitting(false);
        //actions.setErrors(response.data);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: "Data Saved Successfully",
        });
        setTimeout(function () {
          self.state.formResponseData = [];
          self.state.invoiceList = {};
          self.setState({});
        });

        self.getInvoicesList(self.state.selectedStatus);
      }
    });
  };

  getInvoicesList = (status) => {
    var self = this;
    //this.state.initialValues.financialYearOne = this.state.financialYearOne;
    var prm = Object.entries(this.state.initialValues)
      .map(([key, val]) => `${key}=${val}`)
      .join("&");
    prm += "&requestType=" + status;
    var tableCounter,
      counter = 0;

    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };
    fetch(`${apiUrl.apiUrl.url}/transaction/get-invoice-data?` + prm, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        tableCounter = 0;

        self.state.formResponseData = [];
        self.state.invoiceList = data.lists;
        self.state.datatableList = data.lists;

        var cols = data.columns;

        if (cols.length > 0) {
          cols.push({
            name: "Action",
            // selector: "info",
            sortable: false,
            width: "70px",
            cell: (record) => {
              return (
                <div>
                  <span className="tableActionEdit">
                    <a
                      target="_blank"
                      href={`${apiUrl.apiUrl.url}/transaction/print-invoice?id=${record.invoice_id}&type=${this.state.initialValues.reportType}`}
                    >
                      {" "}
                      <FontAwesomeIcon icon={faPrint} />
                    </a>
                  </span>
                </div>
              );
            },
          });
        }

        self.state.columns = cols;
        self.tableCounter = Math.round();
        self.state.invoiceItemList = {};

        self.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  processInvoiceItems = (status) => {
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/transaction/get-invoice-data`,
      data: {
        list: this.state.invoiceList,
        processType: status,
        period: this.state.initialValues.financialYearOne,
        frequency: this.state.initialValues.frequencySelected,
      },
    }).then(function (response) {
      if (!response.data.success) {
        //actions.setSubmitting(false);
        //actions.setErrors(response.data);
      } else {
        console.log("in else", response);
        self.state.formResponseData = [];
        self.state.invoiceList = response.data.lists;
        self.state.datatableList = response.data.lists;
        self.tableCounter = Math.round();
        self.state.invoiceItemList = {};

        self.setState({});
      }
    });
  };

  approveInvoice = () => {
    this.processInvoiceItems(1);
  };

  applyInvoice = () => {
    this.processInvoiceItems(2);
  };

  cancelInvoice = () => {
    this.processInvoiceItems(3);
  };

  rejectInvoice = () => {
    this.processInvoiceItems(0);
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  // handleSelectAll = e => {
  //   setIsCheckAll(!isCheckAll);
  //   setIsCheck(list.map(li => li.id));
  //   if (isCheckAll) {
  //     setIsCheck([]);
  //   }
  // };

  handleClick = (e) => {
    const { id, checked } = e.target;
    console.log("okok", id, checked, e.target.dataset, "str", e, "==");
    var invoiceListObj = this.state.invoiceList;
    var invoiceItemList = this.state.invoiceItemList;
    if (typeof invoiceListObj[id] == "undefined") {
      invoiceListObj[id] = {};
    }

    if (typeof invoiceListObj[id][[e.target.dataset.attr]] == "undefined") {
      invoiceListObj[id][[e.target.dataset.attr]] = {};
    }

    console.log(e.target.dataset, "e.target.dataset.netAmt");

    var uniqueKey =
      id + "-" + e.target.dataset.attr + "-" + e.target.dataset.occupierid;

    if (checked) {
      invoiceListObj[id][e.target.dataset.attr][e.target.dataset.occupierid] = {
        amt: e.target.dataset.netamt,
        invoiceId: e.target.dataset.invoiceid,
      };

      invoiceItemList[uniqueKey] = true;
    } else {
      delete invoiceListObj[id][e.target.dataset.attr][
        e.target.dataset.occupierid
      ];
      delete invoiceItemList[uniqueKey];
    }

    this.state.invoiceList = invoiceListObj;
    this.state.invoiceItemList = invoiceItemList;

    console.log(this.state.invoiceList, "final list", invoiceItemList);

    this.setState({});

    // this.setIsCheck([...isCheck, id]);
    // if (!checked) {
    //   this.setIsCheck(isCheck.filter(item => item !== id));
    // }
  };
  redirectAfterSave = () => {
    this.setState({
      messsagePopup: false,
      popupMessageContent: "",
    });
  };

  sendInvoiceList = () => {
    //console.log("send list", this.state.invoiceList);
    var data = JSON.stringify(this.state.invoiceList);
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/transaction/send-invoice`,
      data: { list: data },
    }).then(function (response) {
      if (!response.data.success) {
        //actions.setSubmitting(false);
        //actions.setErrors(response.data);
      } else {
        self.setState({ messsagePopup: true, popupContent: response.data.msg });
        setTimeout(function () {
          self.state.formResponseData = [];
          self.getInvoicesList(self.state.selectedStatus);
          self.setState({});
        });
      }
    });
  };

  generateInvoice = () => {
    console.log(this.state.invoiceList, "ohh ");
    var self = this;

    if (JSON.stringify(this.state.invoiceItemList) === JSON.stringify({})) {
      self.setState({
        messsagePopup: true,
        popupContent: "Please Select Item to proceed.",
      });
      return false;
    }

    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/transaction/generate-invoice`,
      data: {
        list: this.state.invoiceList,
        companyId: this.state.initialValues.companyId,
        period: this.state.initialValues.financialYearOne,
        frequency: this.state.initialValues.frequencySelected,
        chargeType: this.state.initialValues.chargeTypeSelected,
      },
    }).then(function (response) {
      if (!response.data.success) {
        //actions.setSubmitting(false);
        //actions.setErrors(response.data);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: "Data Saved Successfully",
        });
        setTimeout(function () {
          self.state.formResponseData = [];
          self.getInvoicesList(self.state.selectedStatus);
          self.setState({});
        });
      }
    });
  };

  selectAll = () => this.selectAllCheckboxes(true);

  selectAllCheckboxes = (isSelected) => {
    Object.keys(this.state.formResponseData).forEach((checkbox) => {
      // BONUS: Can you explain why we pass updater function to setState instead of an object?
      this.setState((prevState) => ({
        checkboxes: {
          ...prevState.checkboxes,
          [checkbox]: isSelected,
        },
      }));

      this.state.formResponseData[checkbox][
        this.state.formResponseData[checkbox]["invoice_id"]
      ] = isSelected;
    });
    this.setState({});
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/transactions/generate" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    const handlePerRowsChange = async (newPerPage, page) => { };

    const handlePageChange = (page) => {
      this.setState({ pageNo: page }, () => {
        this.processInvoiceItems(this.state.selectedStatus);
      });
    };

    const handleRowSelected = (state) => {
      console.log(state.selectedRows.length);
      console.log(state.selectedRows);

      var invoiceListObj = {};
      if (state.selectedRows.length > 0) {
        state.selectedRows.forEach(function (items) {
          let leaseId = items["invoice_id"];
          let pId = items["invoice_id"];

          if (typeof invoiceListObj[leaseId] == "undefined") {
            invoiceListObj[leaseId] = {};
          }

          invoiceListObj[leaseId][pId] = true;
        });

        this.state.showStatusOption = true;
      } else {
        this.state.showStatusOption = false;
      }

      this.state.invoiceList = invoiceListObj;
      this.setState({});
    };

    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Transactions</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>Print & Send Invoices</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Print Invoice</a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          // validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.counter = Math.random();
            this.setState({});
          }}
          onSubmit={(values, actions) => {

            if (!this.validator.allValid()) {
              this.validator.getErrorMessages();
              this.validator.showMessages();
              //this.forceUpdate();
              return false;
            }

            this.setState({ selectedStatus: "generate" });
            this.getInvoicesList("generate");
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off">
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      <div className="newGridSectionInner">
                        <label>Landlord Group</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="landlordId"
                            isSearchable="true"
                            onChange={(e) => {
                              this.handleChangeLandlord(e);
                            }}
                            value={{
                              label: this.state.initialValues.groupName,
                              value: this.state.initialValues.groupId,
                            }}
                            options={this.state.landloardList.map((item) => ({
                              label: item.text,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="groupId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Landlord Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetName"
                            onChange={(e) => {
                              this.valueChangeAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetArr.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="assetId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Sub Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="subAssetName"
                            onChange={(e) => {
                              this.valueChangeSubAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.subAssetName,
                              value: this.state.initialValues.subAssetId,
                            }}
                            options={this.state.subAssetArr.map((item) => ({
                              label: item.sub_asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="subAssetName" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Tower Name<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="towerId"
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.state.initialValues.towerId = e.value;
                              this.setState({});
                            }}
                            options={this.state.towerArr.map((item) => ({
                              label: item.tower_name,
                              value: item.id,
                            }))}
                          />
                          {this.validator.message("Tower", this.state.initialValues.towerId, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Charge Type<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="chargeType"
                            onChange={(e) => {
                              this.valueChangeChargeType(e);
                            }}
                            value={this.state.chargeTypeSelected}
                            options={[
                              "RENT(Minimum Guarantee)",
                              "RENT(Revenue Share)",
                              "CAM",
                              "Property Tax",
                              "Marketing Fund Tax",
                              "Parking 2W",
                              "Parking 4W",
                              "Parking Other",
                              "Storage",
                              "Signage",
                            ].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                         {this.validator.message("Charge type", this.state.initialValues.chargeType, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Month<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <DatePicker
                            onChange={(date) => this.setState({ financialYearOne: date })}
                            onBlur={this.handleCalenderOnBlur}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            selected={this.state.financialYearOne}
                            onCalendarClose={this.handleCalenderOnBlur}
                          />
                          {this.validator.message("Month", this.state.financialYearOne, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Invoice Frequency<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="invoiceFrequency"
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.state.initialValues.frequencySelected = e.value;
                              this.state.initialValues.invoiceFrequency = e.value;
                              this.setState({});
                            }}
                            value={this.state.frequencySelected}
                            options={["Monthly"].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          {this.validator.message("Invoice frequency", this.state.initialValues.invoiceFrequency, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Report Type<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="reportType"
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.state.initialValues.reportType = e.value;
                              this.setState({});
                            }}
                            value={this.state.frequencySelected}
                            options={["Invoice", "Credit Note", "Debit Note"].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          {this.validator.message("Report type", this.state.initialValues.reportType, "required", { className: "text-danger" })}
                        </div>
                      </div>
                    </div>

                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" d1isabled={isSubmitting} className="add_button">
                        Search
                      </button>
                      <button type="reset" onClick={this.selectAll} className="reset_button">
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          )}
        </Formik>

        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>


        <DataTable
          title="Invoice List"
          key={this.state.tableCounter}
          columns={this.state.columns}
          data={this.state.datatableList}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={this.state.loading}
          pagination
          paginationServer
          paginationTotalRows={this.state.totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          //subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
          paginationRowsPerPageOptions={[1, 3, 5, 10, 25, 50, 100]}
          selectableRows={true} //{this.state.selectedStatus != 2 && this.state.selectedStatus != 3 ? true : false }
          onSelectedRowsChange={handleRowSelected}
        />

        {this.state.showStatusOption > 0 && (
          <div className="btnContainer">
            <button type="button" onClick={this.sendInvoiceList}>
              Send Mail
            </button>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(LeaseExpiryReport);
